import { render } from "./HowDoesItWorkStepBlock.vue?vue&type=template&id=6a521f2f"
import script from "./HowDoesItWorkStepBlock.vue?vue&type=script&lang=js"
export * from "./HowDoesItWorkStepBlock.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/landing/landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__